import RoleType from "@coworker/enums/roleType";

const rolesTranslations = {
  [RoleType.COWORKER]: "coworkerString",
  [RoleType.COUNTRY_SUPERUSER]: "countrySuperuserString",
  [RoleType.GUEST]: "guestString",
  [RoleType.STOREOWNER]: "storeSuperuserString",
  [RoleType.SUPERUSER]: "globalSuperuserString",
};

export default rolesTranslations;
